import React from 'react'

const ArticleV2DropCap = React.memo(({dropCapColor}) => {
    if (!dropCapColor) return null;
    const gradientColor1 = dropCapColor ? dropCapColor[0] : 'gray'
    const gradientColor2 = dropCapColor ? dropCapColor[1] : 'gray';
    
    const colors = dropCapColor ? dropCapColor.join(', ') : 'gray, gray'
    return (
    <div className="drop-cap">

        <style jsx>{`
            .drop-cap {
                height: 85px;
                width: 85px;
                border-radius: 50%;
                background: red;
                float: left;
                margin-right: 20px;
                background: linear-gradient(to bottom, ${colors});
            }

            @media (max-width: 769px), (pointer: coarse) {
                .drop-cap {
                    height: 70px;
                    width: 70px;
                    // margin-top: 45px;
                }
            }
        `}</style>
    </div>
    )
})

export default ArticleV2DropCap